import React, { useState } from 'react';
import { Code2, Linkedin, Github, Instagram, CreditCard } from 'lucide-react';
import { PaymentModal } from './PaymentModal';
import { LegalModal, LegalDocType } from './LegalModal';
export function Footer() {
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [legalDoc, setLegalDoc] = useState<LegalDocType | null>(null);
  return <footer className="bg-black border-t border-white/5 pt-16 pb-8" data-id="element-132" data-mp="36n3chl6jxmt8">
      <div className="container mx-auto px-6 md:px-12" data-id="element-133" data-mp="3ufjww2drhqvp">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-134" data-mp="3990wknlzgb8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-135" data-mp="3lelyq0q08dl1">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-136" data-mp="3le2j4qntu1a6">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center text-white" data-id="element-137" data-mp="3qcds6z6as7rc">
                <Code2 size={18} data-id="element-138" data-mp="2a19sxkaopkw8" />
              </div>
              <span className="font-heading font-bold text-xl tracking-tight text-white" data-id="element-139" data-mp="2eyjprl0ekyu3">
                Mike's <span className="text-blue-500" data-id="element-140" data-mp="3l8qx26bccnsi">Pro</span> Web Design
              </span>
            </a>
            <p className="max-w-sm mb-6 leading-relaxed text-[#FFFFFF]" data-id="element-141" data-mp="3gbingu49ds2v">
              Custom, high-converting websites built directly by the owner. No
              agency overhead, just pure results and dedicated service.
            </p>
            <div className="flex gap-4" data-id="element-142" data-mp="3qapyvbrfncnc">
              <a href="#" className="w-10 h-10 rounded-full bg-[#111118] border border-white/5 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all" data-id="element-143" data-mp="82icpt2wkaeu">
                <Linkedin size={18} data-id="element-144" data-mp="hrs8biwygb7p" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#111118] border border-white/5 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all" data-id="element-145" data-mp="ctqogvrpg7v6">
                <Instagram size={18} data-id="element-146" data-mp="ms6d8s39f51i" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#111118] border border-white/5 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all" data-id="element-147" data-mp="mtrawqkvf43l">
                <Github size={18} data-id="element-148" data-mp="yruzmehxdfl5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-149" data-mp="18jr0fxbebjt2">
            <h4 className="text-white font-bold mb-6" data-id="element-150" data-mp="18k94vh87p4c2">Quick Links</h4>
            <ul className="space-y-3" data-id="element-151" data-mp="1clmc9vqydfl3">
              <li data-id="element-152" data-mp="1ckkocqou8yly">
                <a href="#services" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-153" data-mp="1cl2se9hqsh4f">
                  Services
                </a>
              </li>
              <li data-id="element-154" data-mp="1mjikofsi9wfi">
                <a href="#portfolio" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-155" data-mp="1ml3gs9ugxnfh">
                  Portfolio
                </a>
              </li>
              <li data-id="element-156" data-mp="3oboltbvt3bfg">
                <a href="#process" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-157" data-mp="3oc6sz3k0ba25">
                  Process
                </a>
              </li>
              <li data-id="element-158" data-mp="2af3ubumo9blq">
                <a href="#pricing" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-159" data-mp="2afdj5evzdcpu">
                  Pricing
                </a>
              </li>
              <li data-id="element-160" data-mp="25mkdmosou0cp">
                <a href="#faq" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-161" data-mp="21mjz745l9p5n">
                  FAQ
                </a>
              </li>
              <li data-id="element-162" data-mp="1wpjsqs4tuke0">
                <button type="button" onClick={() => setIsPaymentOpen(true)} className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-medium transition-colors" data-id="element-163" data-mp="1wlw0dwb4c40v">
                  <CreditCard size={16} data-id="element-164" data-mp="2pa9yec27j0cf" />
                  Make a Payment
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-165" data-mp="2fdf465cyvm3y">
            <h4 className="text-white font-bold mb-6" data-id="element-166" data-mp="2fdymhn6j4cii">Contact</h4>
            <ul className="space-y-3" data-id="element-167" data-mp="18z5ycuyrs9g9">
              <li className="text-[#FFFFFF]" data-id="element-168" data-mp="18w1p3j6g6niq">Los Angeles, CA</li>
              <li data-id="element-169" data-mp="13y9wso1w4ze0">
                <a href="tel:818-381-9905" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-170" data-mp="13xqdb2wle2xv">
                  818-381-9905
                </a>
              </li>
              <li data-id="element-171" data-mp="2wn99w7gymx2f">
                <a href="mailto:mrross23@gmail.com" className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-172" data-mp="2wnr1gqsogn40">
                  mikesproweb@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-173" data-mp="3bk00psckj0gf">
          <p className="text-sm text-[#FFFFFF]" data-id="element-174" data-mp="3fllj1t7vg6y0">
            &copy; {new Date().getFullYear()} Mike's Pro Web Design. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500" data-id="element-175" data-mp="31nx1ovd0jhxp">
            <button type="button" onClick={() => setLegalDoc('privacy')} className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-176" data-mp="36j2hrdjqi2dv">
              Privacy Policy
            </button>
            <button type="button" onClick={() => setLegalDoc('terms')} className="hover:text-blue-400 transition-colors text-[#FFFFFF]" data-id="element-177" data-mp="1v69uaexz803m">
              Terms of Service
            </button>
          </div>
        </div>
      </div>

      <PaymentModal isOpen={isPaymentOpen} onClose={() => setIsPaymentOpen(false)} data-id="element-178" data-mp="1ioz281vyi43m" />

      <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} data-id="element-179" data-mp="1wm46bwc40sw8" />
    </footer>;
}